var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 228 228",
    className: "outlined-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 114,
    r: 114
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8461 109.915H53.0769"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1846 56.1L70.9308 66.8461"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114 33.7615V48.9923"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.815 56.1L157.069 66.8461"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190.154 109.915H174.923"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114 153.915C138.301 153.915 158 134.216 158 109.915C158 85.6148 138.301 65.9154 114 65.9154C89.6995 65.9154 70 85.6148 70 109.915C70 134.216 89.6995 153.915 114 153.915Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.815 163.9L157.069 153.154"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114 186.238V171.008"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1846 163.9L70.9308 153.154"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummer);
export default __webpack_public_path__ + "static/media/summer.66cdf473.svg";
export { ForwardRef as ReactComponent };